<template>
	<div>
        <b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="saveModal" :title="title" size="lg" @ok="ok" @hidden="hidden" :ok-disabled="$store.state.ajax_in_progress || (model.id != null && !$store.getters.hasPermission(['project_task_manager'], ['update']))">
            <div class="row">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.task_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.task_no">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.task_title') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.task_title">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.discipline') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.selectedDiscipline"
                                :options="currentDiscipline"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isDisciplineLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onDisciplineSearch"
                                @input="updateDiscipline"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.selectedDiscipline != null"
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedDiscipline"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.discipline_id != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.drawing') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.selectedDrawing"
                                :options="currentDrawing"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isDrawingLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="info" track-by="id"
                                :selectLabel="''"
                                @search-change="onDrawingSearch"
                                @input="updateDrawing"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.selectedDrawing != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedDrawing"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.from_user') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" disabled class="form-control" v-model="model.loggedUser">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="specialInputs[0]">
                        <div class="col-lg-4">
                            <label>{{ $t('table.to_company') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.selectedToCompany"
                                :options="currentToCompany"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isToCompanyLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onToCompanySearch"
                                @input="updateToCompany($event, 0)"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.selectedToCompany != null"
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedToCompany(0)"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="specialInputs[1]">
                        <div class="col-lg-4">
                            <label>{{ $t('table.to_user') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.selectedUser"
                                :options="currentUser"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isUserLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="fullname" track-by="id"
                                :selectLabel="''"
                                @search-change="onUserSearch"
                                @input="updateUser($event, 1)"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.selectedUser != null"
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedUser(1)"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="specialInputs[2]">
                        <div class="col-lg-4">
                            <label>{{ $t('table.to_team') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.selectedToTeam"
                                :options="currentToTeam"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isToTeamLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onToTeamSearch"
                                @input="updateToTeam($event, 2)"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.selectedToTeam != null"
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedToTeam(2)"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.latest_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.latest_date"></flat-pickr>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.exact_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.exact_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.exact_time') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.exact_time">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.importancy') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.importancy">
                                <option v-for="importancy in important" :value="importancy.code">{{importancy.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.urgency') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.urgency">
                                <option v-for="urgency in urgent" :value="urgency.code">{{urgency.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.status') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.status">
                                <option v-for="status in statuses" :value="status.code">{{status.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.closed') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <toggle-button v-model="model.closed" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
	</div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';
import Multiselect from 'vue-multiselect';

export default {
	name: 'TaskModal',
	components: {
		flatPickr,
		notificationIcons,
		Multiselect
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		specialInputs: {
            type: Array,
            default: function () {
                return [1, 1, 1];
            }
        },
		model: {
			type: Object,
			default: () => ({
                id: null,
				loggedUser: null,
				task_no: null,
				task_title: null,
                by_user_id: null,
                to_company_id: null,
                to_user_id: null,
                to_team_id: null,
                discipline_id: null,
                drawing_id: null,
                latest_date: null,
                exact_date: null,
                exact_time: null,
                importancy: null,
                urgency: null,
                status: null,
                closed: null,
                selectedDiscipline: null,
                selectedDrawing: null,
                selectedToCompany: null,
                selectedUser: null,
                selectedToTeam: null,
			})
		}
	},
    mounted() {
        this.tableNameTranslated = Vue.i18n.translate('general.administrative.task_manager.title_modal');
	},
	data() {
		return {
			currentDiscipline: [],
            isDisciplineLoading: false,

			currentDrawing: [],
            isDrawingLoading: false,

            currentToCompany: [],
            isToCompanyLoading: false,

            currentUser: [],
            isUserLoading: false,

            currentToTeam: [],
            isToTeamLoading: false,
		}
	},
	computed: {
        statuses: {
            get: function () {
                let statuses = this.$store.getters.getTaskStatuses;
                return statuses;
            }
        },
        urgent: {
            get: function () {
                let urgent = this.$store.getters.getTaskUrgent;
                return urgent;
            }
        },
        important: {
            get: function () {
                let important = this.$store.getters.getTaskImportant;
                return important;
            }
        }
    },
    watch: {
        statuses: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        },
        urgent: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        },
        important: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    },
	methods: {
		successMsg(msg) {
			miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
		},
		errorMsg(msg) {
			miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
		},
        infoMsg(msg) {
            miniToastr.info(msg, Vue.i18n.translate('messages.info'), 6000);
        },
        show() {
			this.$refs.saveModal.show();
		},
        hidden() {
            this.$emit('hidden');
            this.clear();
        },
        ok (e) {
            e.preventDefault();
            
            let put_data = {
                project_id:    this.$route.params.id,
                task_no:       this.model.task_no,
                task_title:    this.model.task_title,
                by_user_id:    this.model.by_user_id,
                to_company_id: this.model.to_company_id,
                to_user_id:    this.model.to_user_id,
                to_team_id:    this.model.to_team_id,
                discipline_id: this.model.discipline_id,
                drawing_id:    this.model.drawing_id,
                latest_date:   this.model.latest_date,
                exact_date:    this.model.exact_date,
                exact_time:    this.model.exact_time,
                importancy:    this.model.importancy,
                urgency:       this.model.urgency,
                status:        this.model.status,
                closed:        this.model.closed,
            };

            Object.keys(put_data).forEach(key => {
                if (put_data[key] === '') {
                    put_data[key] = null;
                }
            });

            if (this.model.id != null) {
                let data = http.route('task_manager/' + this.model.id).patch(put_data, true);
                data.then(response => {
                    if (response.isError == false) {
                        if (put_data.closed == 1) {
                            this.infoMsg(Vue.i18n.translate('general.administrative.task_manager.title_modal') + ' ' + Vue.i18n.translate('messages.is_closed'));
                        }
                        this.$emit('onLoadTable');
                        this.$refs.saveModal.hide();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            } else {
                let data = http.route('task_manager').post(put_data, true);
                data.then(response => {
                    if (response.isError == false) {
                        if (put_data.closed == 1) {
                            this.infoMsg(Vue.i18n.translate('general.administrative.task_manager.title_modal') + ' ' + Vue.i18n.translate('messages.is_closed'));
                        }
                        this.$emit('onLoadTable');
                        this.$refs.saveModal.hide();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            }
        },
		clear() {
            this.model.loggedUser    = this.$store.state.user.user.firstname + ' ' + this.$store.state.user.user.lastname;
            this.model.id            = null;
            this.model.task_no       = null;
            this.model.task_title    = null;
            this.model.by_user_id    = null;
            this.model.to_company_id = null;
            this.model.to_user_id    = null;
            this.model.to_team_id    = null;
            this.model.discipline_id = null;
            this.model.drawing_id    = null;
            this.model.latest_date   = null;
            this.model.exact_date    = null;
            this.model.exact_time    = null;
            this.model.importancy    = null;
            this.model.urgency       = null;
            this.model.status        = null;
            this.model.closed        = null;

            this.model.selectedDiscipline = null;
            this.model.selectedDrawing    = null;
            this.model.selectedToCompany  = null;
            this.model.selectedToTeam     = null;
            this.model.selectedUser       = null;
		},
        hideOthers (to_ignore, showAll = false) {
            for (let i = 0; i < 3; i++) {
                if(showAll) {
                    this.specialInputs[i] = true;
                } else {
                    if(i != to_ignore) {
                        this.specialInputs[i] = false;
                    }
                }
            }
        },
        onDisciplineSearch(search) {
            if (search == '') {
                this.currentDiscipline = [];
                
                return false;
            }

            this.isDisciplineLoading = true;
            this.searchDiscipline(search, this);
        },
        searchDiscipline: _.debounce((search, vm) => {
            let data = http.route('discipline?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentDiscipline = response.data;
                }
                vm.isDisciplineLoading = false;
            });
        }, 500),
        updateDiscipline(discipline) {
            this.model.discipline_id = (discipline != null) ? discipline.id : null;
            this.clearSelectedDrawing();
        },
        clearSelectedDiscipline () {
            this.model.selectedDiscipline = null;
            this.model.discipline_id      = null;
            this.clearSelectedDrawing();
        },
        onDrawingSearch(search) {
            if (search == '') {
                this.currentDrawing = [];
                
                return false;
            }

            this.isDrawingLoading = true;
            this.searchDrawing(search, this);
        },
        searchDrawing: _.debounce((search, vm) => {
            let data = http.route('drawing?project_id='+vm.$route.params.id+'&search_select=' + search + '&filters[parent_drawing_id]=null&filters[discipline_id]=' + vm.model.discipline_id).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentDrawing = response.data;
                }
                vm.isDrawingLoading = false;
            });
        }, 500),
        updateDrawing(drawing) {
            this.model.drawing_id = (drawing != null) ? drawing.id : null;
        },
        clearSelectedDrawing () {
            this.model.selectedDrawing = null;
            this.model.drawing_id      = null;
        },
        onToCompanySearch(search) {
            if (search == '') {
                this.currentToCompany = [];
                
                return false;
            }

            this.isToCompanyLoading = true;
            this.searchToCompany(search, this);
        },
        searchToCompany: _.debounce((search, vm) => {
            let data = http.route('company?get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentToCompany = response.data;
                }
                vm.isToCompanyLoading = false;
            });
        }, 500),
        updateToCompany(to_company, id) {
            this.model.to_company_id = (to_company != null) ? to_company.id : null;
            this.hideOthers(id, (to_company == null));
        },
        clearSelectedToCompany (id) {
            this.model.selectedToCompany   = null;
            this.model.to_company_id = null;
            this.hideOthers(id, true);
        },
        onUserSearch(search) {
            if (search == '') {
                this.currentUser = [];
                
                return false;
            }

            this.isUserLoading = true;
            this.searchUser(search, this);
        },
        searchUser: _.debounce((search, vm) => {
            let data = http.route('user/getall?get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentUser = response.data;
                }
                vm.isUserLoading = false;
            });
        }, 500),
        updateUser(user, id) {
            this.model.to_user_id = (user != null) ? user.id : null;
            this.hideOthers(id, (user == null));
        },
        clearSelectedUser (id) {
            this.model.selectedUser     = null;
            this.model.to_user_id = null;
            this.hideOthers(id, true);
        },
        onToTeamSearch(search) {
            if (search == '') {
                this.currentToTeam = [];
                
                return false;
            }

            this.isToTeamLoading = true;
            this.searchToTeam(search, this);
        },
        searchToTeam: _.debounce((search, vm) => {
            let data = http.route('team?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentToTeam = response.data;
                }
                vm.isToTeamLoading = false;
            });
        }, 500),
        updateToTeam(to_team, id) {
            this.model.to_team_id = (to_team != null) ? to_team.id : null;
            this.hideOthers(id, (to_team == null));
        },
        clearSelectedToTeam(id) {
            this.model.selectedToTeam   = null;
            this.model.to_team_id = null;
            this.hideOthers(id, true);
        },
	}
}
</script>

<style scoped>
    select {
        -webkit-appearance:menulist-button;
        -moz-appearance:menulist-button;
    }
</style>


// WEBPACK FOOTER //
// src/components/global/modals/TaskModal.vue